// extracted by mini-css-extract-plugin
export default {"cost-aggregate":"cost-aggregate_cost-aggregate__-Va1F","-active":"cost-aggregate_-active__Z0CG9"};